import ContextModel from "../../Activity/Models/RequestBody/Context/ContextModel";

export default class PostCreateModel {
  public content: string = "";
  public reply_id: string | null = "";
  public discussion_label: string | null = "";
  public discussion_url: string | null = "";
  public anonymous_nickname: string | null = "";
  public context: ContextModel = null;
}
